


























































import { Component, Vue } from 'vue-property-decorator';
import Teacher from '@/service/teacher';
import { Mutation } from 'vuex-class';
import { VueRouter } from 'vue-router/types/router';
import { setLoginStatus } from '@/store/mutations';
import { ZegoClient } from 'webrtc-zego';
@Component({})
export default class Index extends Vue {
    ruleForm = {
        password: '',
    };
    rules = {
        password: [{ trigger: 'blur', validator: this.passwordValify }],
    };

    logo = require('../../assets/images/Logo.png');
    bg = require('../../assets/images/ManageBg.png');

    roomId: string = '';
    cp = '即构课堂';
    name = '即构大班直播课堂';
    time = '2019-10-10 12:00';
    router!: VueRouter;
    userId!: string;

    supportCheck = true;

    mounted() {
        this.roomId = this.$route.params.roomId;
        this.userId = this.$route.query.userId as string;
        this.cp = this.$route.query.cp as string;
        this.name = this.$route.query.name as string;
        this.time = this.$route.query.time as string;
        this.router = this.$router as VueRouter;

        let isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
        let isChrome = navigator.userAgent.includes('Chrome') && (window as any).chrome;
        if (isMobile || !isChrome) {
            this.supportCheck = false;
            this.$message.warning('请在电脑上，使用chrome72+打开该页面');
        } else {
            ZegoClient.supportDetection(
                (result: {
                    capture: boolean;
                    screenSharing: boolean;
                    webRtc: boolean;
                    videoDecodeType: {
                        VP8: boolean;
                    };
                }) => {
                    console.warn('supportDetection', result);
                    if (!result.webRtc || !result.screenSharing || !result.videoDecodeType.VP8) {
                        let info = ['当前浏览器不支持:'];
                        !result.webRtc && info.push('webrtc,');
                        !result.screenSharing && info.push('屏幕共享,');
                        !result.videoDecodeType.VP8 && info.push('vp8视频编码,');
                        info.push('请在电脑上，使用chrome72+打开该页面');
                        this.$message.warning(info.join());
                        this.supportCheck = false;
                    }
                },
                () => {
                    this.$message.warning('请在电脑上，使用chrome72+打开该页面');
                    this.supportCheck = false;
                },
            );
        }
    }

    @Mutation(setLoginStatus)
    setLoginStatus!: (login: boolean) => void;

    private passwordValify(rule: any, value: string, callback: (err?: Error) => void) {
        if (!value) {
            callback(new Error('请输入密码'));
        } else {
            Teacher.classVerify(this.ruleForm.password, this.roomId, this.userId).then((data: any) => {
                if (data.msg && data.msg.code === 200) {
                    this.setLoginStatus(true);
                    callback();
                } else {
                    this.setLoginStatus(false);
                    if (data.msg && data.msg.message && data.msg.message.includes('no room exists')) {
                        callback(new Error('课程已结束'));
                    } else {
                        callback(new Error('密码错误，请重新输入'));
                    }
                }
            });
        }
    }

    public submitForm(): void {
        const form = this.$refs['ruleForm'] as any;
        form.validate((valiRes: boolean) => {
            if (valiRes) {
                this.router.push({ path: '/push/' + this.roomId, query: this.$route.query });
            }
        });
    }
}
